import FilePreviewRowWeb from './FilePreviewRow.web';
import FilePreviewRowMobile from './FilePreviewRow.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? FilePreviewRowMobile : FilePreviewRowWeb;
